// extracted by mini-css-extract-plugin
export default {"root":"SelectedSbatGroupsForBulkUpdate_root__lrhye","selectedSbatGroup":"SelectedSbatGroupsForBulkUpdate_selectedSbatGroup__37RAk"};